import { useLazyQuery } from '@apollo/client'
import { useMarketplace } from '@src/hooks/useMarketplace'
import { GetMyOrdersDocument } from '@src/pages/MyOrders/queries/__generated__/GetMyOrders.graphql-interface'
import { useTranslation } from 'react-i18next'
import { supportFormValidation } from './validation'
import { CountryCode } from 'libphonenumber-js'

export const useSupportForm = () => {
  const { t } = useTranslation('supportForm')
  const { country } = useMarketplace()
  const [validateOrder] = useLazyQuery(GetMyOrdersDocument, {
    fetchPolicy: 'network-only',
  })

  const formatOrderNumber = (input: string): string => {
    if (input.length >= 12) {
      return `${input.slice(0, 6)}-${input.slice(6, 9)}-${input.slice(
        9,
        12
      )}-${input.slice(12)}`
    }
    return input
  }

  const validateOrderExists = async (orderNumber: string) => {
    if (!orderNumber || orderNumber.trim() === '') return null

    const cleaned = orderNumber.replace(/\D/g, '')
    const formattedOrderNumber = formatOrderNumber(orderNumber)

    const { data } = await validateOrder({
      variables: {
        input: { pageSize: 100 },
      },
    })

    if (!data?.orders?.edges) return null

    const matchedOrder = data.orders.edges.find(edge => {
      const dbOrderNumber = edge.node.orderNumber || ''
      const cleanDbOrderNumber = dbOrderNumber.replace(/\D/g, '')

      return (
        dbOrderNumber === orderNumber ||
        dbOrderNumber === formattedOrderNumber ||
        cleanDbOrderNumber === cleaned
      )
    })

    return matchedOrder
      ? {
          ...matchedOrder.node,
          outletName: matchedOrder.node.outlet?.displayName,
        }
      : null
  }

  const getSupportFormValidation = (currentSubject?: string) => {
    return supportFormValidation(
      currentSubject,
      t,
      (country.ISO3166Alpha2 as CountryCode) || 'GB'
    )
  }

  return {
    getSupportFormValidation,
    validateOrderExists,
    formatOrderNumber,
  }
}
